export const requestsStyles = {
  box: {
    display: 'flex',
    flexDirection: 'column',
  },
}
